import type { AddressInputStepData } from "./AddressInputStep.tsx";
import type { ErrorSeverity } from "../../types/error";
import { DEFAULT_ERROR_SEVERITY } from "../../types/error";

export type AddressInputStepState = {
    currentAddress: AddressWithPrediction;
    isLoading: boolean;
    error: string | null;
    errorSeverity?: ErrorSeverity;
};

export type AddressInputStepAction =
    | { type: "HYDRATE"; payload: AddressInputStepData | undefined }
    | { type: "SET_ADDRESS"; payload: AddressWithPrediction }
    | { type: "SET_LOADING"; payload: boolean }
    | { type: "SET_ERROR"; payload: string | null; severity?: ErrorSeverity };

const emptyAddress: AddressWithPrediction = {
    address: "",
    prediction: null,
};

export const initialAddressInputStepState = (
    stepData: AddressInputStepData | undefined
): AddressInputStepState => ({
    currentAddress: stepData?.currentAddress ?? emptyAddress,
    isLoading: false,
    error: null,
    errorSeverity: DEFAULT_ERROR_SEVERITY,
});

export const addressInputStepReducer = (
    state: AddressInputStepState,
    action: AddressInputStepAction
): AddressInputStepState => {
    switch (action.type) {
        case "HYDRATE":
            return initialAddressInputStepState(action.payload);
        case "SET_ADDRESS":
            return {
                ...state,
                currentAddress: action.payload,
                error: null,
            };
        case "SET_LOADING":
            return {
                ...state,
                isLoading: action.payload,
            };
        case "SET_ERROR":
            return {
                ...state,
                error: action.payload,
                errorSeverity: action.severity ?? DEFAULT_ERROR_SEVERITY,
                isLoading: false,
            };
        default:
            return state;
    }
};
